import * as api from 'services/api'

const topic = {
	state: {
		id: '',
		subjectList: {},
		blocks: [],
		comments: [],
		hasComments: false,
		area: {
			show: false,
			id: '',
			next:'',
			title:'',
			list: [],
			index:''
		}
	},
	mutations: {
		'topic:update:id'(state, id) {
			state.id = id;
		},
		'topic:update:list' (state, payload) {
			state.subjectList = payload.subjectList;
			state.blocks = payload.blocks;	
		},
		'topic:update:comments' (state, comments) {
			if(comments.length > 0) {
				state.hasComments = true;
			}
			state.comments.push(...comments);
		},
		'topic:show:area'(state, payload) {
			const area = state.area;
			area.show = true;
			area.id = payload.id;
			area.next=payload.next;
			area.title=payload.title;
			area.index=payload.index;
		},
		'topic:update:topicList'(state, {more,list}) {
			//const area = state.area;
			
			if(more.next){
				if(list.length > 0) {
					state.blocks[state.area.index].articles.push(...list);
					state.blocks[state.area.index].page=more
					
				}
			}
			else{
				if(list.length > 0) {
					state.blocks[state.area.index].articles.push(...list);
					state.blocks[state.area.index].page=more
					
				}
			}
			//state.area.loading = false;
		},
		// 'topic:update:areaLoading'(state, loading) {
		// 	state.area.loading = loading;
		// },
		'topic:hide:area'(state) {
			const area = state.area;
			area.show = false;
			area.id = '';
			area.title = '';
			area.maxid = '';
			area.list = [];
			area.hasMore = true;
		}
	},
	actions: {
		async 'topic:init'({commit, dispatch}, id) {
			commit('topic:update:id', id);
			// 获取列表数据
			dispatch('topic:update:list');
			// 获取评论数据
			//dispatch('topic:update:comments');
		},
		async 'topic:update:list'({commit, state}) {
			const res = await api.getSubjectList({articleId: state.id,size:"5"});
			if(res.code === 0) {
				const subjectList = res.item;
				const blocks = res.item.blocks || [];
				commit('topic:update:list', {subjectList, blocks});
			}
		},
		// async 'topic:update:comments'({commit, state}) {
		// 	// const res = await api.getHotComments({articleId: state.id,sysCode:"subject"});
		// 	// if(res.result.code === 0) {
		// 	// 	const data = res.data;
		// 	// 	commit('topic:update:comments', data);
		// 	// }
		// },
		async 'topic:show:area'({commit, dispatch}, area) {
			console.log(area)
			commit('topic:show:area', area);
			// 获取区块新闻列表
			dispatch('topic:update:topicList');
		},
		async 'topic:update:topicList' ({commit,state}){
			const res = await api.getTopicBlockList({articleId:state.area.id,pageToken:state.area.next,size:"5"});
			if(res.code === 0 && !Jt.array.isEmpty(res.items)){
				let more=res.page;
				let list=res.items;
				commit('topic:update:topicList',{more,list})
			}
		}
		// async 'topic:update:areaList'({commit, state}) {
		// 	commit('topic:update:areaLoading', true);
		// 	console.log(state)
			
		// 	const res = await api.getTopicBlockList({articleId: state.id,pageToken:"",size:"5"});
		// 	if(res.code === 0 && !Jt.array.isEmpty(res.items)) {
		// 		let more=res.page;
		// 		let list=res.items;
		// 		commit('topic:update:areaList', {more,list});
		// 	}
		// },
		// async 'topic:hide:area'({commit, state}) {
		// 	commit('topic:hide:area');
		// }
	},
	getters: {
		'topic:subjectList': state =>  {
			return state.subjectList;
		},
		'topic:blocks': state => {
			return state.blocks;
		},
		'topic:comments': state => {
			return state.comments;
		},
		'topic:hasComments': state => {
			return state.hasComments;
		},
		'topic:area': state => {
			console.log(state.area.list)
			return state.area;
		}
	}
};

export default topic;


// WEBPACK FOOTER //
// ./src/store/modules/topic.js